<script>
    import Coins from "./coins/coins.svelte";
    import Gems  from "./gems/gems.svelte";

    export let type;
    export let amount;
    export let prevAmount = 0;
    export let options = {};

    const el = {
        coins : Coins,
        gems  : Gems
    };
</script>

<svelte:component this={el[type]} {amount} {options} {prevAmount}/>



